import { Date_Picker } from 'components/DatePicker';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import fetchData from 'utils/fetchData';

export default function JobPositionBatch() {
    const { id } = useParams();
    const [model, setModel] = useState({});
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();

    useEffect(() => {
        if (id)
            LoadData();
    }, [id]);

    async function LoadData() {
        var pToast = toast.loading('Loading data...');
        try {
            var pResponse = await fetchData.Post('/api/JobPositionBatches/Get', {
                id: id
            });
            if (pResponse.fullCount != 1) {
                toast.error('Record not found');
                setModel({});
                return;
            }
            setModel(pResponse.rows[0]);
        } catch (e) {
            toast.error(e);
        } finally {
            toast.dismiss(pToast);
        }
    }

    const SaveButtonLabel = () => {
        if (id)
            return 'Update';
        else
            return 'Save';
    };

    const handleSubmit = async () => {
        var pToast = toast.loading('Saving data...');
        try {
            var pResponse = await fetchData.Post('/api/JobPositionBatches/Save', model);
            await MySwal.fire({
                title: "Job Position Batch Was Saved Successfully",
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "OK",
            });
            navigate('/job-position-batches');
            // onChangeValue(pResponse.id, 'id');
        } catch (e) {
            MySwal.fire({
                title: "Error",
                text: e,
                icon: "error"
            });
        } finally {
            toast.dismiss(pToast);
        }
    };

    function onChangeValue(value, key) {
        setModel(prevState => ({
            ...prevState,
            [key]: value
        }));
    }

    function onChangeTextValue(e, key) {
        onChangeValue(e.target.value, key);
    }

    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-12 py-4 gap-4 ">
                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Batch No.<span className="text-red-600">*</span>
                    </label>
                    <input
                        type="text"
                        //  id="username"
                        value={model.num}
                        onChange={e => onChangeTextValue(e, 'num')}
                        className="inputs"
                        autoComplete="off"
                    />
                </div>

                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Batch Date<span className="text-red-600">*</span>
                    </label>
                    <Date_Picker
                        data={model.batchDate}
                        setData={x => onChangeValue(x, 'batchDate')}
                    />
                </div>

                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Recepient Name<span className="text-red-600">*</span>
                    </label>
                    <input
                        type="text"
                        //  id="username"
                        value={model.recepientName}
                        onChange={e => onChangeTextValue(e, 'recepientName')}
                        className="inputs"
                        autoComplete="off"
                    />
                </div>

                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Recepient Title<span className="text-red-600">*</span>
                    </label>
                    <input
                        type="text"
                        value={model.recepientTitle}
                        onChange={e => onChangeTextValue(e, 'recepientTitle')}
                        className="inputs"
                        autoComplete="off"
                    />
                </div>

                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Date From
                    </label>
                    <Date_Picker
                        data={model.dateFrom}
                        setData={x => onChangeValue(x, 'dateFrom')}
                    />
                </div>

                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Date To
                    </label>
                    <Date_Picker
                        data={model.dateTo}
                        setData={x => onChangeValue(x, 'dateTo')}
                    />
                </div>

                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Prepared By<span className="text-red-600">*</span>
                    </label>
                    <input
                        type="text"
                        value={model.preparedByName}
                        onChange={e => onChangeTextValue(e, 'preparedByName')}
                        className="inputs"
                        autoComplete="off"
                    />
                </div>

                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Prepared By Title<span className="text-red-600">*</span>
                    </label>
                    <input
                        type="text"
                        value={model.preparedByTitle}
                        onChange={e => onChangeTextValue(e, 'preparedByTitle')}
                        className="inputs"

                        autoComplete="off"
                    />
                </div>

                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Attested By<span className="text-red-600">*</span>
                    </label>
                    <input
                        type="text"
                        value={model.attestedByName}
                        onChange={e => onChangeTextValue(e, 'attestedByName')}
                        className="inputs"
                        autoComplete="off"
                    />
                </div>

                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Attested By Title<span className="text-red-600">*</span>
                    </label>
                    <input
                        type="text"
                        value={model.attestedByTitle}
                        onChange={e => onChangeTextValue(e, 'attestedByTitle')}
                        className="inputs"
                        autoComplete="off"
                    />
                </div>
            </div>

            <div className="flex items-end justify-end">
                <button
                    onClick={handleSubmit}
                    className="btn-submit text-white text-base font-semibold py-3 px-6"
                >
                    {SaveButtonLabel()}
                </button>
            </div>
        </div>
    )
}
